import { isBoolean, isRecord } from '@metools/tcheck';
import { useRootStore } from '@qsrsoft/myq-core';

export function isQsrAdmin(): boolean {
  const rootStore = useRootStore();
  const user = rootStore.user as unknown;

  if (isRecord(user) && isBoolean(user.qsrAdmin)) {
    return user.qsrAdmin;
  }

  return false;
}
